import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'help-text',
  templateUrl: './help-text.component.html',
  styleUrls: ['./help-text.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HelpTextComponent {
  @Input() public blockDisplay: boolean = false;
  @Input() public displayAbove: boolean = false;
  @Input() public displayInCenter: boolean = false;
  @Input() public displayOnLeft: boolean = false;
  @Input() public displayRedText: boolean = false;
  @Input() public filterText: string = null;
  @Input() public helpText: string;
  @Input() public hoverText: string;
  @Input() public icon: string = 'info_outline';
  @Input() public is3pSize: boolean = false;
  @Input() public isMediumIcon: boolean = false;
  @Input() public isSmallIcon: boolean = false;
  @Input() public strategicGuidanceText: string = null;

  public show: boolean = false;

  public showHelpText() {
    this.show = true;
  }

  public hideHelpText() {
    this.show = false;
  }
}
